import React from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode
} from 'office-ui-fabric-react/lib/DetailsList';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import StepZilla from 'react-stepzilla';
import Cookies from "universal-cookie";

import HttpService from '../service/HttpService';
import Header from '../component/Header';

class Initialize extends React.Component {
   render() {
    const policies = this.props.policies;

    return (
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-lg6">
            <Dropdown
              placeHolder="Seleccione un cliente"
              label="Cliente"
              name="client"
              onChanged={ ( item ) => {
                this.props.updateItem( item.id, 'client' );
              } }
              options={ this.props.clients } />
          </div>
          <div className="ms-Grid-col ms-sm12 ms-lg6">
            <Dropdown
              placeHolder="Seleccione una póliza"
              label="Póliza"
              name="policy"
              onChanged={ ( item ) => {
                this.props.updateItem( item.id, 'policy' );
              } }
              options={ policies } />
          </div>
        </div>
        <div className="ms-Grid-row" style={{ marginTop: 20 }}>
          <div className="ms-Grid-col ms-sm12 ms-lg-12">
            <p style={{ marginBottom: 10 }}>Tipo de siniestro a denunciar</p>
              <PrimaryButton text="Automotor" style={{ marginRight: 10 }} onClick={ () => {
                this.props.onStepNext( 'car' );
                this.props.jumpToStep(1);
              } } />
              <DefaultButton text="Otros" onClick={ () => {
                this.props.onStepNext( 'others' );
                this.props.jumpToStep(1);
              }} />
          </div>
        </div>
      </div>
    );
  }
}

class Data extends React.Component {
  render() {
    return (
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-lg12">
            <TextField name="datetime" label="Fecha del siniestro" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-lg12">
            <TextField name="description" multiline rows={5} label="Descripción" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
        </div>
        <div className="ms-Grid-row" style={{ marginTop: 20 }}>
          <div className="ms-Grid-col ms-sm12 ms-lg-12">
            { this.props.type == 'car' && 
              <PrimaryButton text="Continuar" style={{ marginRight: 10 }} onClick={ () => {
                this.props.jumpToStep(2);
              } } />
            }
            {
              this.props.type == 'others' &&
              <PrimaryButton text="Denunciar" style={{ marginRight: 10 }} onClick={ () => {
                this.props.onFinish();
              } } />
            }
          </div>
        </div>
      </div>
    )
  }
}

class Car extends React.Component {
  render() {
    return (
      <div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-lg12">
            <TextField name="street" label="Calle o intersección" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
        </div>
        <div className="ms-Grid-row" style={{ marginTop: 20 }}><div className="ms-Grid-col ms-sm12 ms-lg12"><h3>Datos del conductor</h3></div></div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-lg4">
            <TextField name="driverName" label="Nombre" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
          <div className="ms-Grid-col ms-sm12 ms-lg4">
            <TextField name="driverSurname" label="Apellido" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
          <div className="ms-Grid-col ms-sm12 ms-lg4">
            <TextField name="driverLicence" label="Licencia" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
        </div>
        <div className="ms-Grid-row" style={{ marginTop: 20 }}><div className="ms-Grid-col ms-sm12 ms-lg12"><h3>Datos del tercero</h3></div></div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-lg4">
            <TextField name="partyName" label="Nombre" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
          <div className="ms-Grid-col ms-sm12 ms-lg4">
            <TextField name="partySurname" label="Apellido" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
          <div className="ms-Grid-col ms-sm12 ms-lg4">
            <TextField name="partyPhone" label="Teléfono" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
        </div>
        <div className="ms-Grid-row" style={{ marginTop: 20 }}><div className="ms-Grid-col ms-sm12 ms-lg12"><h3>Datos del vehículo</h3></div></div>
        <div className="ms-Grid-row" style={{ marginBottom: 40 }}>
          <div className="ms-Grid-col ms-sm12 ms-lg4">
            <TextField name="partyCar" label="Nombre" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
          <div className="ms-Grid-col ms-sm12 ms-lg4">
            <TextField name="partyCarModel" label="Apellido" onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
          <div className="ms-Grid-col ms-sm12 ms-lg4">
            <TextField name="partyCarPatent" label="Patente"  onChange={ ( item ) => { this.props.updateItem( item, null )} }/>
          </div>
        </div>
        <div className="ms-Grid-row" style={{ marginTop: 20, paddingBottom: 20 }}>
          <div className="ms-Grid-col ms-sm12 ms-lg-12">
            <PrimaryButton text="Denunciar" style={{ marginRight: 10 }} onClick={ () => {
              this.props.onFinish();
            } } />
          </div>
        </div>
      </div>
    )
  }
}

class Resume extends React.Component {
  render() {
    return (
      <div>Acá va el resumen del siniestro previo a ser guardado en la base de datos</div>
    )
  }
}

export default class SinesterWizard extends React.Component {
  http = new HttpService();

  toPost = {};

  constructor( props ) {
    super( props );

    let cookies = new Cookies();
    let session = cookies.get( 'session' );

    if( !session ) {
      window.location.href = '/auth';
    }

    this.state = {
      clients: [],
      _policies: [],
      policies: [],
      sinester: {},
      action: 'car'
    }
  }
  componentDidMount() {
    let loader = this.refs.header.loader().loading( 'Cargando clientes...' );
    
    this.http
      .getClients()
      .then( clients => {
        this.setState({ clients: clients });

        this.http
          .getPolicies()
          .then( policies => {
            this.setState({ policies: policies, _policies: policies });

            loader.finish();
          })
          .catch( this.errorHandler );
      })
      .catch( this.errorHandler );
  }

  updateItem = ( item, name = null ) => {
    if( name !== null) {
      this.toPost[name] = item;
    } else {
      this.toPost[item.target.name] = item.target.value;
    }
  }

  filterPolicies = ( id ) => {
    var filtered = [];

    for( let i=0; i<this.state._policies.length; i++ ) {
      let p = this.state._policies[i];

      if ( p.client == id ) {
        filtered.push( p );
      }
    }

    this.setState({ policies: filtered });
  }

  finishHandler = () => {
    let loader = this.refs.header.loader().loading( 'Guardando cambios...' );

    this.http
      .saveSinester( this.toPost )
      .then( ( sinesters ) => {
        document.location.href = '/sinesters/' +  this.toPost.client;
      })
      .catch( this.errorHandler );
  }

  render() {
    const steps = [
      { name:"Tipo de siniestro", component: <Initialize clients={ this.state.clients } policies={ this.state.policies } updateItem={ ( id, name ) => {
        this.updateItem( id, name );

        if( name == 'client' ) {
          this.filterPolicies( id );
        }
      } } onStepNext={ type => this.setState({ action: type })} /> },
      { name:"Descripción del siniestro", component: <Data updateItem={ ( id, name ) => {
        this.updateItem( id, name );

        if( name == 'client' ) {
          this.filterPolicies( id );
        }
      } } type={ this.state.action } onFinish={ this.finishHandler } /> },
      { name:"Siniestro automotor", component: <Car  updateItem={ ( id, name ) => {
        this.updateItem( id, name );

        if( name == 'client' ) {
          this.filterPolicies( id );
        }
      } } onFinish={ this.finishHandler } /> }
    ];

    return(
      <Fabric>
        <Header title="Denuncia interna de siniestro" ref="header" />
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg1"></div>
            <div className="ms-Grid-col ms-sm-12 ms-lg10">
              <div className='step-progress'>
                <StepZilla steps={steps} stepsNavigation={false} showNavigation={false} onStepChange={ ( step ) => console.log( this.toPost ) }/>
              </div>
            </div>
          </div>
        </div>
      </Fabric>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screen/SinesterWizard.jsx